import {
  ShellAuthData,
  ShellPermissions,
} from '@robinpowered/dashboard-apps-common';

type AuthBridgeSubscriber = (state: {
  authData: ShellAuthData | null;
  permissions: ShellPermissions | null;
}) => void;

/**
 * Creates an auth bridge instance. The subscribers set and resolved values
 * are encapsulated in the closure — no module-level state. The instance is
 * created once in AppShell and passed explicitly to registerApplications,
 * which forwards it to each micro-frontend via customProps.
 */
export function createAuthBridge() {
  const subscribers = new Set<AuthBridgeSubscriber>();
  let authData: ShellAuthData | null = null;
  let permissions: ShellPermissions | null = null;

  return {
    get authData(): ShellAuthData | null {
      return authData;
    },
    get permissions(): ShellPermissions | null {
      return permissions;
    },
    resolveAuthData(data: ShellAuthData): void {
      authData = data;
      subscribers.forEach((cb) => cb({ authData, permissions }));
    },
    resolvePermissions(perms: ShellPermissions): void {
      permissions = perms;
      subscribers.forEach((cb) => cb({ authData, permissions }));
    },
    subscribe(cb: AuthBridgeSubscriber): () => void {
      subscribers.add(cb);
      return () => {
        subscribers.delete(cb);
      };
    },
  };
}

export type AuthBridge = ReturnType<typeof createAuthBridge>;
